module.exports = __webpack_public_path__ + "static/media/Companies.d129eba3.png";